module.exports = "/_next/static/images/fce552f9c68297562dbad5bf1ed21192-challenge-the-system-xs@3x.jpg.webp";